"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselHeadingArea = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _CarouselHeadingArea = require("./CarouselHeadingArea.styles");
/**
 * Wrapper for the Carousel heading text.
 *
 * @since 8.71.0
 */
var CarouselHeadingArea = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_CarouselHeadingArea.StyledCarouselHeadingArea, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.CarouselHeadingArea = CarouselHeadingArea;
CarouselHeadingArea.displayName = 'CarouselHeadingArea';